import React from 'react';
import { noop } from 'lodash';
import { string, func, shape } from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import { srcSetMapToAttribute } from '@fiverr-private/variations_display/src/utils';
import { BRIEF_DATA } from '../../Listings/constants';
import BriefFrame from '../BriefFrame';
import NameIndustries from '../forms/NameIndustries';
import { IMAGES } from './constants';
import classes from './index.module.scss';

const ShortBrief = ({
    className = '',
    briefData,
    setBriefData = noop,
    onSubmit = noop,
}) => {
    const steps = [
        {
            formContent: (
                <NameIndustries
                    briefData={briefData}
                    setBriefData={setBriefData}
                />
            ),
            sideContent: (
                <img
                    src={IMAGES.MOCKUP.imgUrl}
                    srcSet={srcSetMapToAttribute(IMAGES.MOCKUP.srcSet)}
                />
            ),
        },
    ];

    return (
        <div className={classes.mpiBrief}>
            <BriefFrame
                className={className}
                onSubmit={onSubmit}
                submitButtonLabel={
                    <I18n k="variations_display.marketplace_listing.brief.show_me_logos" />
                }
                steps={steps}
            />
            <img
                className={classes.blurredListImg}
                src={IMAGES.BACKGROUND.imgUrl}
                srcSet={srcSetMapToAttribute(IMAGES.BACKGROUND.srcSet)}
            />
        </div>
    );
};

ShortBrief.propTypes = {
    className: string,
    onSubmit: func,
    briefData: shape(BRIEF_DATA),
    setBriefData: func,
};

export default ShortBrief;
